import gql from 'graphql-tag';

export const TRIGGER_AUDIENCE_GROOMING_MUTATION = gql`
  mutation TriggerAudienceGroomingMutation($articleId: Int!, $audienceTemplate: AudienceTemplateInput!) {
    triggerAudienceGrooming(articleId: $articleId, audienceTemplate: $audienceTemplate) {
      grooming {
        articleId
        audienceTemplateId
        audienceTemplateType
        status
      }
      errors
    }
  }
`;
